import s from "./styles.module.scss";

const Button = ({
  children,
  onClick,
  type = "button",
  className = "",
  disabled = false,
  variant = "primary",
  size = "medium",
  icon,
  iconPosition = "left",
  fullWidth = false,
  iconOnly = false,
  loading = false,
  ...props
}) => {
  const getButtonClass = () => {
    let classes = [s.customButton];

    classes.push(s[`customButton--${variant}`]);
    classes.push(s[`customButton--${size}`]);

    if (disabled) classes.push(s["customButton--disabled"]);
    if (loading) classes.push(s["customButton--loading"]);
    if (fullWidth) classes.push(s["customButton--fullWidth"]);
    if (iconOnly) classes.push(s["customButton--iconOnly"]);

    if (className) classes.push(className);

    return classes.join(" ");
  };

  return (
    <button
      type={type}
      className={getButtonClass()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon ? (
        <div className={s.buttonContent}>
          {iconPosition === "left" && (
            <span className={s.buttonIcon}>{icon}</span>
          )}
          <span className={s.buttonText}>{children}</span>
          {iconPosition === "right" && (
            <span className={s.buttonIcon}>{icon}</span>
          )}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
